import { TSelectedAddressContextValue } from '../../../types/addressField.types';

const usePlaceService = () => {
  const getPlaceDetails = (
    placeId: string,
    callback: (details: { address: TSelectedAddressContextValue }) => void
  ): void => {
    if (window.google) {
      const placesService = new window.google.maps.places.PlacesService(
        document.createElement('div')
      );

      placesService.getDetails({ placeId }, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const addressComponents = place?.address_components || [];
          const country = { name: '', isoCode: '' };
          const state = { name: '', isoCode: '' };
          let zipcode = '';
          let city = '';

          addressComponents.forEach((component) => {
            if (
              city === '' &&
              (component.types.includes('locality') ||
                component.types.includes('postal_town') ||
                component.types.includes('administrative_area_level_3'))
            ) {
              city = component.long_name;
            }
            if (component.types.includes('country')) {
              country.name = component.long_name;
              country.isoCode = component.short_name;
            }
            if (component.types.includes('administrative_area_level_1')) {
              state.name = component.long_name;
              state.isoCode = component.short_name;
            }
            if (component.types.includes('postal_code')) {
              zipcode = component.long_name;
            }
          });

          callback({
            address: {
              country,
              state,
              zipcode,
              city,
            },
          });
        }
      });
    } else {
      console.error('Error fetching place details: ', status);
    }
  };

  return { getPlaceDetails };
};

export default usePlaceService;
